const state = {
  rawMaterials: [],
  productTypes: [],
  overdueCj: [],
  receivables: 0,
  daily_transactions: 0
};

export default {
  namespaced: true,
  state,
  mutations: {
    setRawMaterials(state, rawMaterials) {
      state.rawMaterials = rawMaterials;
    },
    setProductTypes(state, productTypes) {
      state.productTypes = productTypes;
    },
    setOverdueCj(state, overdueCj) {
      state.overdueCj = overdueCj;
    },
    setReceivables(state, receivables) {
      state.receivables = receivables;
    },
    setDailyTransactions(state, daily_transactions) {
      state.daily_transactions = daily_transactions;
    }
  },
  actions: {
    fetchRawMaterials({ commit }) {
      axios.get('api/v1/dashboard/rawmatreorder').then(response => {
        commit('setRawMaterials', response.data);
      });
    },
    fetchProductTypes({ commit }) {
      axios.get('api/v1/dashboard/productreorder').then(response => {
        commit('setProductTypes', response.data);
      });
    },
    fetchOverdueCj({ commit }) {
      axios.get('api/v1/dashboard/overduecj').then(response => {
        commit('setOverdueCj', response.data);
      });
    },
    fetchReceivables({ commit }) {
      axios.get('api/v1/dashboard/receivables').then(response => {
        commit('setReceivables', response.data);
      });
    },
    fetchDailyTransactions({ commit }) {
      axios.get('api/v1/dashboard/dailytransactions').then(response => {
        commit('setDailyTransactions', response.data);
      });
    }
  }
};
